<template functional>
  <div class="ine-form__title-wrapper">
    <h1 class="ine-form__title">{{ props.header }}</h1>
    <p class="ine-form__tagline" v-html="props.tagline"></p>
    <small v-if="props.alert && props.alert.length" class="ine-form__alert">{{
      props.alert
    }}</small>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    header: {
      type: String,
      required: true,
    },
    tagline: {
      type: String,
      required: true,
    },
    alert: {
      type: String,
      required: false,
    },
  },
}
</script>
